import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Types and Action Creators
 */
const { Types, Creators } = createActions({
    formToggle: null,
    formSetVisibility: ['visibility'],
});

export const ShowFormTypes = Types;
export default Creators;

/**
 * Initial State
 */
export const INITIAL_STATE = Immutable({
    visibility: false,
});

/**
 * Toggles the form visibilty
 *
 * @param {Object} state
 * @return {Object}
 */
export const toggle = (state) =>
    state.merge({ visibility: !state.visibility });

/**
 * Sets the visibilty
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const setVisibility = (state, action) =>
    state.merge({ visibility: action.visibility });

/**
 *  Hookup Reducers To Types
 */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.FORM_TOGGLE]: toggle,
    [Types.FORM_SET_VISIBILITY]: setVisibility,
});
